import {Box, CardMediaProps, Stack} from "@mui/material";
import {useState, useEffect} from "react";
import {api} from "@core/api";
import {skipToken} from "@reduxjs/toolkit/query";
import {Image} from "@mui/icons-material";

type AsyncImageProps = CardMediaProps & {
  id: string | undefined; // ID dell'immagine da caricare
  height: string | number;
  width?: string | number;
  fallbackSrc?: string; // URL dell'immagine di fallback
  fallbackNode?: JSX.Element;
  size?: "cover" | "contain" | "auto";
};

const AsyncImage: React.FC<AsyncImageProps> = ({
  id,
  fallbackSrc,
  fallbackNode,
  height,
  width,
  size = "cover",
  ...props
}) => {
  const {
    data: imageSrc,
    isLoading,
    isFetching,
  } = api.usePreviewFileQuery(id ?? skipToken);
  const [imgSrc, setImgSrc] = useState<string | undefined>(fallbackSrc);

  useEffect(() => {
    setImgSrc(imageSrc ? imageSrc : fallbackSrc);
  }, [imageSrc, fallbackSrc]);

  if (isLoading || isFetching) {
    return (
      <Stack
        height={height}
        width={width}
        position={"relative"}
        sx={{display: "flex", justifyContent: "center", alignItems: "center"}}>
        <Image />
      </Stack>
    );
  }

  if (imgSrc) {
    return (
      <Box
        height={height}
        width={width ?? "100%"}
        sx={{
          ...props.sx,
          backgroundImage: `url(${imgSrc})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: size,
          backgroundPosition: "center",
        }}
      />
    );
  }

  if (fallbackNode) {
    return (
      <Stack height={height} width={width} sx={props.sx}>
        {fallbackNode}
      </Stack>
    );
  }

  return null;
};

export {AsyncImage};
